import {
   InternationalClient,
} from "Services/API/API";
import { useApiClient } from "Services/API/useApiClient";
import { useEffect, useMemo, useState } from "react";
import { isSupportedCountry, isValidLocation } from "../helpers";
import { IPlaceSelection } from "./usePlaceAddress";

interface UseCtaParamProps {
   placeSelection: IPlaceSelection | undefined;
   inputValue: string;
}

interface UseCtaParamReturn {
   isLocationSelected: boolean;
   emptyValue: boolean;
   validLocation: boolean;
   supportedCountry: boolean;
}

export const useCtaParam = ({
   placeSelection,
   inputValue,
}: UseCtaParamProps): UseCtaParamReturn => {
   const emptyValue = useMemo(() => !inputValue?.length, [inputValue]);

   const [countriesWithCCPayment, setCountriesWithCCPayment] = useState<
      string[]
   >([]);

   const apiInternationalClient = useApiClient(InternationalClient);

   useEffect(() => {
      const fetch = async () => {
         const countries = await apiInternationalClient.countries();
         setCountriesWithCCPayment(countries);
      };

      fetch();
   }, []);

   const isLocationSelected = useMemo(
      () => placeSelection?.placePrediction.text === inputValue,
      [placeSelection, inputValue]
   );

   const validLocation = useMemo(
      () =>
         (!!placeSelection?.details && isValidLocation(placeSelection.details.location) && isLocationSelected) || false,
      [placeSelection, isLocationSelected]
   );

   const supportedCountry = useMemo(
      () =>
         !!placeSelection?.details?.addressParts.country?.shortText &&
         (isSupportedCountry(placeSelection.details.addressParts.country.shortText) ||
            countriesWithCCPayment.includes(
               placeSelection.details.addressParts.country.shortText.toLocaleLowerCase()
            )),
      [placeSelection, countriesWithCCPayment]
   );

   return {
      emptyValue,
      isLocationSelected,
      validLocation,
      supportedCountry,
   };
};
